import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isCallCenterEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.CallCenterEnabled',
    false,
  )
}
